import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function AubergineMeatballs() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Aubergine Meatballs</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>1 Onion<br></br>2 Large
        Aubergines<br></br>4 Cloves of Garlic<br></br>
        Handful of Parsley<br></br>
        175g White Bread<br></br>
        200g Tinned Green Lentils<br></br>
        30g Parmesan<br></br>
        1/2 Tsp Chilli Flakes<br></br>
        800g Tinned Chopped Tomatoes<br></br>
        150g Mozzarella<br></br>
        Handful of Basil<br></br>
        Salt<br></br>
        Pepper<br></br>
        Olive Oil<br></br>
      </Typography>

      <Typography>
        Heat your oven to 200°C. <br></br>
        Finely slice your onion. Dice your aubergines into small chunks. Finely
        chop your garlic and parsley.<br></br>
        Heat a saute pan over a medium heat with a little olive oil. Add your
        sliced onion and cook until softened, about 10 mins.<br></br>
        Drain your lentils, then tip them onto a baking tray. Bake for 15 mins
        until they have dried out slightly. <br></br>
        <br></br>
        Add your aubergine chunks to the same pan as your onions with a pinch of
        salt and a drizzle of olive oil. Fry for 5 mins until totally soft and
        tender. Tip in half of your garlic and cook for another 2 mins. Allow
        your aubergines and lentils to cool slightly.<br></br>
        Add your bread to the food processor and whizz to crumbs, then remove
        25g to save until later. Tip the aubergines and lentils into your food
        processor, along with your onions, parmesan, all but a tbsp of your
        parsley and salt and pepper. Whizz to a paste, then season to taste.
        <br></br>
        Roll your mixture into 12 equal sized balls. <br></br>
        Place them on a parchment lined baking tray, then drizzle with a little
        olive oil.<br></br>
        Bake for 40 mins until crisp. <br></br>
        <br></br>
        Meanwhile, make your tomato sauce. Heat a little olive oil in a saute
        pan over medium heat. Add your remaining garlic and chilli flakes, and
        cook for 1 min. Tip in your tinned tomatoes and add a sprig of basil.
        Simmer for 25 mins until reduced.<br></br>
        Whizz up with a stick blender if you like it smoother, then season to
        taste with salt and pepper. <br></br>
        Heat your grill to high. <br></br>
        Mix your remaining 25g of breadcrumbs with chopped parsley. <br></br>
        Pour your sauce into a baking dish. Add your meatballs, then tears over
        your mozzarella. Grate over a little parmesan and sprinkle on your
        breadcrumbs, then grill for 5 mins. <br></br>
        Top with basil leaves, then serve! <br></br>
      </Typography>
    </Card>
  );
}
